/**
 * changes https://support.oysterhr.com  urls to /zendesk/sso  link
 * @param string:  normal support url
 * @returns string :  new url
 */

export const useTransformZendeskUrl = (oldUrl: string): string => {
  const OLD_SUPPORT_BASE_URL = "https://support.oysterhr.com"
  const SSO_PATHNAMES = ["/"]

  if (oldUrl.startsWith(OLD_SUPPORT_BASE_URL)) {
    const pathName = new URL(oldUrl).pathname
    if (SSO_PATHNAMES.includes(pathName)) {
      return "/zendesk/sso"
    } else {
      const returnUrl = encodeURIComponent(oldUrl)
      return `/zendesk/sso?return_to=${returnUrl}`
    }
  } else {
    return oldUrl
  }
}
